// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b8067ddf","469":"d053e5da","561":"846e1ac0"}[chunkId] + ".chunk.js";
};